import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { filter } from 'lodash-es';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { selectTodaysCalls } from '../../store/selectors';
import { addMessage, removeMessage } from '../../store/slices/feedbackSlice';
import { MessageSeverity } from '../../types';
import type { Call } from '../../types';

const UNANSWERED_CALL_PERIOD = 30 * 60 * 1000;
const UNANSWERED_CALL_CHECK_INTERVAL = 60 * 1000;
const MSG_ID = 'FEEDBACK@UNANSWERED_CALL_CHECK_MESSAGE_ID';

/** Monitors for unanswered calls and shows feedback messages. */
export default function UnansweredCallsWatchdog() {
  const dispatch = useAppDispatch();
  const callRecords = useAppSelector(selectTodaysCalls);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), UNANSWERED_CALL_CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const periodStart = dayjs().subtract(UNANSWERED_CALL_PERIOD, 'ms');
    const newerCalls = (callRecords || []).filter((c: Call) => dayjs(c.incoming_at).isAfter(periodStart));
    const finishedCalls = newerCalls.filter((c: Call) => c.finished_at != null);
    const unansweredCalls = finishedCalls.filter((c: Call) => c.agent_count === 0);

    const lastCallUnanswered = finishedCalls.slice(0, 1).filter((c: Call) => c.agent_count === 0).length > 0;
    const periodCallsUnanswered = unansweredCalls.length > 0;

    if (lastCallUnanswered) {
      dispatch(addMessage({
        id: MSG_ID,
        message: 'Propustili ste poziv jer telefoni nisu spojeni na internet',
        severity: MessageSeverity.ERROR,
        autoRemove: false,
        timeout: -1,
      }));
    } else if (periodCallsUnanswered) {
      dispatch(addMessage({
        id: MSG_ID,
        message: `U proteklih ${UNANSWERED_CALL_PERIOD / (60 * 1000)} minuta propustili ste poziv jer telefoni nisu bili spojeni na internet`,
        severity: MessageSeverity.WARNING,
        autoRemove: false,
        timeout: -1,
      }));
    } else {
      dispatch(removeMessage(MSG_ID));
    }
  }, [callRecords, tick, dispatch]);

  return null;
}
